/* CAMPAIGN CASHBACKS DATA */
export const GET_CAMPAIGN_CASHBACKS_LIST = "GET_CAMPAIGN_CASHBACKS_LIST";
export const SET_CAMPAIGN_CASHBACKS_LIST = "SET_CAMPAIGN_CASHBACKS_LIST";

export const GET_CAMPAIGN_CASHBACK_PROFILE = "GET_CAMPAIGN_CASHBACK_PROFILE";
export const SET_CAMPAIGN_CASHBACK_PROFILE = "SET_CAMPAIGN_CASHBACK_PROFILE";
export const UPDATE_CAMPAIGN_CASHBACK_PROFILE =
  "UPDATE_CAMPAIGN_CASHBACK_PROFILE";

/* CAMPAIGNS CASHBACKS ACTIONS */
export const ADD_CAMPAIGN_CASHBACKS = "ADD_CAMPAIGN_CASHBACKS";
export const DELETE_CAMPAIGN_CASHBACKS = "DELETE_CAMPAIGN_CASHBACKS";

/* LOADER */
export const SHOW_CAMPAIGN_CASHBACKS_LOADER = "SHOW_CAMPAIGN_CASHBACKS_LOADER";
export const HIDE_CAMPAIGN_CASHBACKS_LOADER = "HIDE_CAMPAIGN_CASHBACKS_LOADER";
